import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { ReactComponent as PhoneLineIcon } from '../../assets/icons/phone-line.svg';
import { ReactComponent as MailLineIcon } from '../../assets/icons/mail-line.svg';
import InnovationMap from './Map';
import ContactApi from '../../api/contact';

const schema = yup.object({
  fullName: yup.string().required(),
  email: yup.string().email().required(),
  message: yup.string().required(),
}).required();

const Contact = () => {
  const [loading, setLoading] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    setLoading(true);
    let {
      fullName = "",
      email = "",
      message = "",
    } = data;
    let res = {};
    try {
      res = await ContactApi.sendMessage(fullName, email, message);
    } catch {}
    toast(res.message || "An Error Occurred", { type: res.success ? "success" : "error" });
    if (res.success && !res.error) {
      reset(); 
    }

    setLoading(false);
  };

  return (
    <div className="row align-items-center justify-content-center bg-warning" style={{ paddingTop: '5rem', paddingBottom: '5rem' }}>
      <div className="col-md-10 col-12">
        <div className="row justify-content-center bg-white" style={{ height: '100%' }}>
          <div className="col-md-7 col-12 px-0 align-self-stretch" style={{ height: '100%' }}>
            <div id="contact" className="container bg-white py-5 px-5">
              <h3 className="text-info mb-5">
                Send us a message
              </h3>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="form-group mb-4">
                  <label htmlFor="fullName" className="text-secondary">
                    <strong>
                      Full Name
                    </strong>
                  </label>
                  <input 
                    type="text" 
                    name="fullName" 
                    className="form-control rounded-3" 
                    placeholder="Bayes Thiery" 
                    { ...register("fullName") }
                  />
                  { errors.fullName && <p className="text-danger font-sm mt-2"> { errors.fullName?.message || "Full Name is required" } </p>}
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="email" className="text-secondary">
                    <strong>
                     Email Address 
                    </strong>
                  </label>
                  <input 
                    // type="email" 
                    name="email" 
                    className="form-control rounded-3" 
                    placeholder="johndoe@mail.com"
                    { ...register("email") }
                  />
                  { errors.email && <p className="text-danger font-sm mt-2"> { errors.email?.message || "Email Adress is required" } </p>}
                </div>
                <div className="form-group mb-4">
                  <label htmlFor="message" className="text-secondary">
                    <strong>
                      Message
                    </strong>
                  </label>
                  <textarea 
                    type="text" 
                    name="message" 
                    className="form-control rounded-3" 
                    placeholder="Bayes Thiery" 
                    rows="5"
                    { ...register("message") }
                  ></textarea>
                  { errors.message && <p className="text-danger font-sm mt-2"> { errors.message?.message || "Message is required" } </p>}
                </div>

                <div className="form-group mb-4">
                  <button type="submit" className="btn btn-primary rounded-3 px-4 py-3" disabled={loading}>
                    {
                      loading ? (
                        <div className="d-flex justify-items-center align-items-center">
                          <div className="spinner-border" role="status">
                          </div>
                          <div className="" style={{ width: "1rem"}}></div>
                          <div>
                            Loading...
                          </div>
                        </div>
                      ) : (
                        <span>
                          Send Message
                        </span>
                      )
                    }
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-5 col-12 px-0">
            <div className="container bg-primary py-5">
              <h3 className="text-white mb-5">
                Contact info
              </h3>
              <p className="text-danger">
                <strong>
                  Administrative Office
                </strong>
              </p>
              <p className="text-white">
                11 Lateef Jakande Road, Agidingbi, Lagos, Nigeria
              </p>
              <p className="text-danger">
                <strong>
                  Warehouse
                </strong>
              </p>
              <p className="text-white">
                12 Ganiyu Street, Rafco Bus-stop, Ope-ilu Road, Ogun State, Nigeria
              </p>
              <div className="d-flex justify-content-left align-items-center mb-3">
                <div className="" style={{ marginRight: '10px' }}>
                  <PhoneLineIcon />
                </div>
                <div className="text-white">
                  + 234 803 456 0999, + 234 809 456 0999
                    <br/>
                  + 234 807 473 7976, + 234 802 401 0934
                </div>
              </div>
              <div className="d-flex justify-content-left align-items-center mb-3">
                <div className="" style={{ marginRight: '10px' }}>
                  <MailLineIcon />
                </div>
                <div className="text-white">
                  info@innovationa.com.ng
                </div>
              </div>
              <div style={{ width: '100%', height: '100%' }}>
                <InnovationMap />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Contact };
